import { useEffect } from 'react';

/**
 * Dev-only performance monitor. Logs API timings and detects long tasks.
 * Renders nothing.
 */
export const PerformanceMonitor = () => {
  useEffect(() => {
    if (process.env.NODE_ENV !== 'development') return;

    const formatFetchTarget = (input: RequestInfo | URL): string =>
      typeof input === 'string' ? input : input instanceof URL ? input.href : input.url;

    const originalFetch = window.fetch;
    window.fetch = async (...args) => {
      const startTime = performance.now();
      const target = formatFetchTarget(args[0]);
      try {
        const response = await originalFetch(...args);
        const duration = performance.now() - startTime;
        console.log(`[Perf] ${target} - ${duration.toFixed(2)}ms`);
        return response;
      } catch (error) {
        const duration = performance.now() - startTime;
        console.error(`[Perf] FAIL ${target} - ${duration.toFixed(2)}ms`);
        throw error;
      }
    };

    let observer: PerformanceObserver | undefined;
    if ('PerformanceObserver' in window) {
      try {
        observer = new PerformanceObserver((list) => {
          list.getEntries().forEach((entry) => {
            if (entry.duration > 50) {
              console.warn(`[Perf] Long task: ${entry.duration.toFixed(2)}ms`);
            }
          });
        });
        observer.observe({ entryTypes: ['longtask'] });
      } catch {
        /* PerformanceObserver non supporté */
      }
    }

    return () => {
      window.fetch = originalFetch;
      observer?.disconnect();
    };
  }, []);

  return null;
};

export default PerformanceMonitor;
